module.exports = __webpack_public_path__ + "img/CompScope_Space_00.4b7958c0.png";